import React, { ReactNode } from "react";

export interface IParagraphProps {
  size?: "xs" | "sm" | "md" | "lg";
  weight?: "regular" | "medium" | "semiBold" | "bold";
  className?: string;
  id?: string;
  "data-test"?: string;
  children: ReactNode;
}

export const P: React.FC<IParagraphProps> = ({
  size = "sm",
  weight = "regular",
  className = "",
  children,
  ...rest
}) => {
  const sizes = {
    xs: "text-xs leading-3",
    sm: "text-sm leading-4",
    md: "text-base leading-5",
    lg: "text-lg leading-6",
  };

  const weights = {
    regular: "font-normal",
    medium: "font-medium",
    semiBold: "font-semibold",
    bold: "font-bold",
  };

  return (
    <p {...rest} className={`${sizes[size]} ${weights[weight]} ${className}`}>
      {children}
    </p>
  );
};
